import React from "react";
import type { CollapseProps } from "antd";
import { Collapse, InputNumber, Skeleton, Table } from "antd";
import { EditOutlined, LoadingOutlined, SaveOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Tag,
} from "antd";

import { useContext, useEffect, useState } from "react";
import { handleDecimalValues, Utils } from "../../../../Utilities/Utils";
import { useClient } from "../../../Context/ClientContext";
import { dayjs } from "../../../../Utilities/dayjs";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../../Services/LedgerService";
import VoucherServices, {
  ClosingEntry_Type,
  IClosingEntryItems,
  IClosingEntryResponseModel,
  IVoucherModel,
  Party_Tax,
  Voucher_Type,
} from "../../../Services/VoucherServices";
import "../../../Common/Acc_Common.css";
import { ColumnsType } from "antd/es/table";
import {
  Adjust_Type,
  IItemInvCloOpResponse,
  IItemInvDetail,
  IItemInventory,
} from "../../../Services/ItemsService";

const ClosingEntries: React.FC = () => {
  const [tempLedgerForm] = Form.useForm();
  const [permaLedgerForm] = Form.useForm();
  const [itemsform] = Form.useForm();
  const [dateForm] = Form.useForm();
  const [stockValueForm] = Form.useForm();
  const { currentClient, companySettings } = useClient();
  const { openNotification } = useContext(notificationContext);
  const [period, setPeriod] = useState<{ from: string; to: string }>({
    from: dayjs(currentClient?.financialYearBegin).toISOString(),
    to: dayjs(currentClient?.financialYearBegin)
      .add(1, "year")
      .add(-1, "day")
      .endOf("day")
      .toISOString(),
  });

  const [loading, setLoading] = useState(false);
  const [isDisabled, setDisabled] = useState<boolean>(false);
  const [journalId, setJournalId] = useState<string>("");
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  //credit and debit total according to blocks
  const [debitTotalTempLedger, setDebitTotalTempLedger] = useState<number>(0);
  const [creditTotalTempLedger, setCreditTotalTempLedger] = useState<number>(0);
  const [debitTotalPermaLedger, setDebitTotalPermaLedger] = useState<number>(0);
  const [creditTotalPermaLedger, setCreditTotalPermaLedger] =
    useState<number>(0);
  const [debitTotalItems, setDebitTotalItems] = useState<number>(0);
  const [creditTotalItems, setCreditTotalItems] = useState<number>(0);
  const [closingEntries, setClosingEntries] =
    useState<IClosingEntryResponseModel>();

  //party ledger according to blocks
  const [partyLedgerOptionTempLedger, setPartyLedgerOptionTempLedger] =
    useState<any[]>([]);
  const [partyLedgerOptionPermaLedger, setPartyLedgerOptionPermaLedger] =
    useState<any[]>([]);
  const [partyLedgerOptionOtherAsset, setPartyLedgerOptionOtherAsset] =
    useState<any[]>([]);

  const [initialStockValue, setInitialStockValue] = useState<number>(0);
  const [totalStockValue, setTotalStockValue] = useState<number>(0);
  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: "",
  });
  const { TextArea } = Input;

  const getTempLedgers = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.AllExpensesnIncomes
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionTempLedger(res);
      }
    });
  };
  const getPermaLedgers = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.AssetnLiabilities
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionPermaLedger(res);
      }
    });
  };
  const getOtherThanFixedAssets = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.AssetsOtherThanFixedAssets
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionOtherAsset(res);
      }
    });
  };
  const showClosingEntry = async (
    companyId: string,
    from: string,
    to: string
  ) => {
    if (companyId) {
      await VoucherServices.ShowClosingEntries(companyId, from, to).then(
        (res) => {
          if (res?.status && res?.result) {
            let tempLedgersData: any = [];
            let permaLedgersData: any = [];
            setClosingEntries({
              ...res?.result,
              itemsClosingInvDetail: res?.result?.itemsClosingInvDetail?.map(
                (cl) => {
                  stockValueForm.setFieldValue(cl.id, cl.stockValue);
                  return cl;
                }
              ),
            });
            setInitialStockValue(
              res?.result?.itemsClosingInvDetail?.reduce(
                (acc: number, cl: IItemInvCloOpResponse) =>
                  acc + cl.stockValue!,
                0
              ) || 0
            );
            setTotalStockValue(
              res?.result?.itemsClosingInvDetail?.reduce(
                (acc: number, cl: IItemInvCloOpResponse) =>
                  acc + cl.stockValue!,
                0
              ) || 0
            );
            res?.result?.closingVouchers?.map(
              (clsEntry: IClosingEntryItems) => {
                switch (clsEntry?.entryType) {
                  case ClosingEntry_Type.ExpensesnIncome:
                    clsEntry?.voucher?.effectiveLedger?.map((eLed: any) => {
                      var eTmpData = {
                        ...eLed,
                        debit: eLed.isDebitNature
                          ? Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            )
                          : 0,
                        credit: eLed.isDebitNature
                          ? 0
                          : Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            ),
                        id: {
                          key: eLed.id,
                          value: eLed.id,
                          label: eLed.ledgerName,
                          title: "",
                          // title: eLed.partyOrTax,
                        },
                      };
                      tempLedgersData.push(eTmpData);
                    });
                    clsEntry?.voucher?.partyLedger?.map((eLed: any) => {
                      var pTmpData = {
                        ...eLed,
                        debit: eLed.isDebitNature
                          ? Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            )
                          : 0,
                        credit: eLed.isDebitNature
                          ? 0
                          : Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            ),
                        id: {
                          key: eLed.id,
                          value: eLed.id,
                          label: eLed.ledgerName,
                          title: "",
                          // title: eLed.partyOrTax,
                        },
                      };
                      tempLedgersData.push(pTmpData);
                    });
                    break;
                  case ClosingEntry_Type.AssetsnLiabities:
                    clsEntry?.voucher?.effectiveLedger?.map((eLed: any) => {
                      var eTmpData = {
                        ...eLed,
                        debit: eLed.isDebitNature
                          ? Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            )
                          : 0,
                        credit: eLed.isDebitNature
                          ? 0
                          : Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            ),
                        id: {
                          key: eLed.id,
                          value: eLed.id,
                          label: eLed.ledgerName,
                          title: "",
                          // title: eLed.partyOrTax,
                        },
                      };
                      permaLedgersData.push(eTmpData);
                    });
                    clsEntry?.voucher?.partyLedger?.map((eLed: any) => {
                      var pTmpData = {
                        ...eLed,
                        debit: eLed.isDebitNature
                          ? Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            )
                          : 0,
                        credit: eLed.isDebitNature
                          ? 0
                          : Utils.getFormattedNumber(
                              Math.round(Math.abs(eLed.amount) * 100) / 100
                            ),
                        id: {
                          key: eLed.id,
                          value: eLed.id,
                          label: eLed.ledgerName,
                          title: "",
                          // title: eLed.partyOrTax,
                        },
                      };
                      permaLedgersData.push(pTmpData);
                    });
                    break;
                }
              }
            );
            if (tempLedgersData?.length > 0) {
              tempLedgerForm.setFieldsValue({
                partyLedgerTempLedgers: tempLedgersData,
                narration: res?.result?.closingVouchers.find(
                  (vch: IClosingEntryItems) =>
                    vch.entryType === ClosingEntry_Type.ExpensesnIncome
                )?.voucher?.narration,
              });
              setDebitTotalTempLedger(
                Math.abs(
                  tempLedgersData.reduce(
                    (acc: number, rec: any) => acc + Utils.getNumber(rec.debit),
                    0
                  )
                )
              );
              setCreditTotalTempLedger(
                Math.abs(
                  tempLedgersData.reduce(
                    (acc: number, rec: any) =>
                      acc + Utils.getNumber(rec.credit),
                    0
                  )
                )
              );
            }
            if (permaLedgersData?.length > 0) {
              permaLedgerForm.setFieldsValue({
                partyLedgerPermaLedgers: permaLedgersData,
                narration: res?.result?.closingVouchers.find(
                  (vch: IClosingEntryItems) =>
                    vch.entryType === ClosingEntry_Type.AssetsnLiabities
                )?.voucher?.narration,
              });

              setDebitTotalPermaLedger(
                Math.abs(
                  permaLedgersData.reduce(
                    (acc: number, rec: any) => acc + Utils.getNumber(rec.debit),
                    0
                  )
                )
              );
              setCreditTotalPermaLedger(
                Math.abs(
                  permaLedgersData.reduce(
                    (acc: number, rec: any) =>
                      acc + Utils.getNumber(rec.credit),
                    0
                  )
                )
              );
            }
          }
        }
      );
    }
  };

  // To handle stock value change
  const handleStockValueChange = () => {
    debugger;
    let tempLedgerFormValues = tempLedgerForm.getFieldsValue();
    let permaLedgerFormValues = permaLedgerForm.getFieldsValue();
    let diffStockAmount = totalStockValue - initialStockValue;

    let selPnLTempLedger = tempLedgerFormValues?.partyLedgerTempLedgers?.find(
      (led: any) => led.ledgerName === "Profit & Loss A/c"
    );
    let formPnLValue =
      Utils.getNumber(selPnLTempLedger.credit) !== 0
        ? Utils.getNumber(selPnLTempLedger.credit)
        : Utils.getNumber(selPnLTempLedger.debit);
    let increaseInStock = diffStockAmount > 0;
    let pnLInDebit = Utils.getNumber(selPnLTempLedger.debit) > 0;
    let changePnLLedger = false;
    if (increaseInStock && pnLInDebit) {
      changePnLLedger = formPnLValue - diffStockAmount > 0 ? false : true;
    }
    if ((increaseInStock && !pnLInDebit) || (!increaseInStock && pnLInDebit)) {
      changePnLLedger = false;
    }
    if (!increaseInStock && !pnLInDebit) {
      changePnLLedger = diffStockAmount + formPnLValue > 0 ? false : true;
    }

    let selStockTempLedger = tempLedgerFormValues?.partyLedgerTempLedgers?.find(
      (led: any) => led.ledgerName === "Closing Stock"
    );
    let selPnLPermaLedger =
      permaLedgerFormValues?.partyLedgerPermaLedgers?.find(
        (led: any) => led.ledgerName === "Profit & Loss A/c"
      );
    let selStockPermaLedger =
      permaLedgerFormValues?.partyLedgerPermaLedgers?.find(
        (led: any) => led.ledgerName === "Closing Stock"
      );
    //To update the tempLedger entries
    if (
      diffStockAmount !== 0 &&
      Utils.getNumber(selPnLTempLedger.debit) !== 0
    ) {
      selPnLTempLedger.debit = changePnLLedger
        ? Utils.getNumber(selPnLTempLedger.debit) - diffStockAmount
        : Utils.getFormattedNumber(
            Utils.getNumber(selPnLTempLedger.debit) - diffStockAmount
          );
      selPnLTempLedger.amount -= diffStockAmount;
    }
    if (
      diffStockAmount !== 0 &&
      Utils.getNumber(selPnLTempLedger.credit) !== 0
    ) {
      selPnLTempLedger.credit = changePnLLedger
        ? Utils.getNumber(selPnLTempLedger.credit) + diffStockAmount
        : Utils.getFormattedNumber(
            Utils.getNumber(selPnLTempLedger.credit) + diffStockAmount
          );
      selPnLTempLedger.amount += diffStockAmount;
    }
    if (changePnLLedger) {
      if (Utils.getNumber(selPnLTempLedger.credit) !== 0) {
        selPnLTempLedger.debit = Utils.getFormattedNumber(
          Math.abs(Utils.getNumber(selPnLTempLedger.credit))
        );
        selPnLTempLedger.credit = Utils.getFormattedNumber(0);
      } else {
        selPnLTempLedger.credit = Utils.getFormattedNumber(
          Math.abs(Utils.getNumber(selPnLTempLedger.debit))
        );
        selPnLTempLedger.debit = Utils.getFormattedNumber(0);
      }
    }
    if (
      diffStockAmount !== 0 &&
      Utils.getNumber(selStockTempLedger.debit) !== 0
    ) {
      selStockTempLedger.debit = Utils.getFormattedNumber(
        Utils.getNumber(selStockTempLedger.debit) + diffStockAmount
      );
      selStockTempLedger.amount += diffStockAmount;
    }
    let prevTempFormValues =
      tempLedgerFormValues?.partyLedgerTempLedgers?.filter(
        (led: any) =>
          led.id?.key !== selPnLTempLedger?.id?.key &&
          led.id?.key !== selStockTempLedger?.id?.key
      );
    let newTempFormValues = [
      ...prevTempFormValues,
      selStockTempLedger,
      selPnLTempLedger,
    ];
    tempLedgerForm.setFieldValue("partyLedgerTempLedgers", newTempFormValues);
    setDebitTotalTempLedger(
      Math.abs(
        newTempFormValues.reduce(
          (acc: number, rec: any) => acc + Utils.getNumber(rec.debit),
          0
        )
      )
    );
    setCreditTotalTempLedger(
      Math.abs(
        newTempFormValues.reduce(
          (acc: number, rec: any) => acc + Utils.getNumber(rec.credit),
          0
        )
      )
    );

    //To update the permaLedger entries
    if (
      diffStockAmount !== 0 &&
      Utils.getNumber(selPnLPermaLedger.debit) !== 0
    ) {
      selPnLPermaLedger.debit = changePnLLedger
        ? Utils.getNumber(selPnLPermaLedger.debit) + diffStockAmount
        : Utils.getFormattedNumber(
            Utils.getNumber(selPnLPermaLedger.debit) + diffStockAmount
          );
      selPnLPermaLedger.amount += diffStockAmount;
    }
    if (
      diffStockAmount !== 0 &&
      Utils.getNumber(selPnLPermaLedger.credit) !== 0
    ) {
      selPnLPermaLedger.credit = changePnLLedger
        ? Utils.getNumber(selPnLPermaLedger.credit) - diffStockAmount
        : Utils.getFormattedNumber(
            Utils.getNumber(selPnLPermaLedger.credit) - diffStockAmount
          );
      selPnLPermaLedger.amount -= diffStockAmount;
    }
    if (changePnLLedger) {
      if (Utils.getNumber(selPnLPermaLedger.credit) !== 0) {
        selPnLPermaLedger.debit = Utils.getFormattedNumber(
          Math.abs(Utils.getNumber(selPnLPermaLedger.credit))
        );
        selPnLPermaLedger.credit = Utils.getFormattedNumber(0);
      } else {
        selPnLPermaLedger.credit = Utils.getFormattedNumber(
          Math.abs(Utils.getNumber(selPnLPermaLedger.debit))
        );
        selPnLPermaLedger.debit = Utils.getFormattedNumber(0);
      }
    }

    if (
      diffStockAmount !== 0 &&
      Utils.getNumber(selStockPermaLedger.credit) !== 0
    ) {
      selStockPermaLedger.credit = Utils.getFormattedNumber(
        Utils.getNumber(selStockPermaLedger.credit) + diffStockAmount
      );
      selStockPermaLedger.amount += diffStockAmount;
    }

    let prevPermaFormValues =
      permaLedgerFormValues?.partyLedgerPermaLedgers?.filter(
        (led: any) =>
          led.id?.key !== selPnLPermaLedger?.id?.key &&
          led.id?.key !== selStockPermaLedger?.id?.key
      );
    let newPermaFormValues = [
      ...prevPermaFormValues,
      selStockPermaLedger,
      selPnLPermaLedger,
    ];
    permaLedgerForm.setFieldValue(
      "partyLedgerPermaLedgers",
      newPermaFormValues
    );
    setDebitTotalPermaLedger(
      Math.abs(
        newPermaFormValues.reduce(
          (acc: number, rec: any) => acc + Utils.getNumber(rec.debit),
          0
        )
      )
    );
    setCreditTotalPermaLedger(
      Math.abs(
        newPermaFormValues.reduce(
          (acc: number, rec: any) => acc + Utils.getNumber(rec.credit),
          0
        )
      )
    );
    setInitialStockValue(totalStockValue);
  };
  //
  // *****
  const fetchAllLedgersnEntries = async () => {
    return await Promise.all([
      getTempLedgers(),
      getPermaLedgers(),
      getOtherThanFixedAssets(),
      showClosingEntry(currentClient?.id!, period.from, period.to),
    ]);
  };

  // opening balance get api according to blocks
  useEffect(() => {
    setLoading(true);
    fetchAllLedgersnEntries()
      .then(() => {
        setLoading(false);
      })
      .catch((ex: any) => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // post (save) add OpeningBalance api
  const postClosingEntry = async () => {
    try {
      debugger;
      /// To get the voucher Date
      let voucherDate = dateForm.getFieldValue("date");
      //

      /// Updating the ItemsClosingInvDetail
      let itemsClosingInvDetail = closingEntries?.itemsClosingInvDetail;
      let newInvDetail = stockValueForm.getFieldsValue();
      //
      itemsClosingInvDetail = itemsClosingInvDetail?.map((inv) => ({
        ...inv,
        stockValue: newInvDetail[inv.id] ?? inv.stockValue,
      }));
      //// Handling of tempLedgers Form
      // To get Form Value
      let tempLedgersFormValues = tempLedgerForm.getFieldsValue();
      // To select PnL ledger value
      let selPnLTempFormValue =
        tempLedgersFormValues.partyLedgerTempLedgers.find(
          (led: any) => led.ledgerName === "Profit & Loss A/c"
        );
      // To select closing stock ledger value
      let selStockTempFormValue =
        tempLedgersFormValues.partyLedgerTempLedgers.find(
          (led: any) => led.ledgerName === "Closing Stock"
        );
      // To get PnL Ledger from Closing Entry
      let selPnLEntryValue =
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.ExpensesnIncome)
          ?.voucher.effectiveLedger.find(
            (led: any) => led.ledgerName === "Profit & Loss A/c"
          ) ??
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.ExpensesnIncome)
          ?.voucher.partyLedger.find(
            (led: any) => led.ledgerName === "Profit & Loss A/c"
          );
      // To set the changed amount
      if (selPnLEntryValue) {
        selPnLEntryValue.amount = selPnLTempFormValue.amount;
        selPnLEntryValue.isDebitNature =
          selPnLEntryValue.amount > 0 ? false : true;
      }

      // To select the tempLedger Voucher from closing entry
      let selTempLedgerVoucher: IVoucherModel =
        closingEntries?.closingVouchers.find(
          (cl) => cl.entryType === ClosingEntry_Type.ExpensesnIncome
        )?.voucher!;
      selTempLedgerVoucher = {
        ...selTempLedgerVoucher,
        effectiveLedger:
          selTempLedgerVoucher?.effectiveLedger &&
          selPnLEntryValue?.id &&
          Array.isArray(selTempLedgerVoucher.effectiveLedger) &&
          selTempLedgerVoucher.effectiveLedger.some(
            (led) => led?.id === selPnLEntryValue?.id
          )
            ? [
                ...selTempLedgerVoucher.effectiveLedger.filter(
                  (led) => led?.id !== selPnLEntryValue?.id
                ),
                selPnLEntryValue,
              ]
            : selTempLedgerVoucher.effectiveLedger ?? [],
        partyLedger:
          selTempLedgerVoucher?.partyLedger &&
          selPnLEntryValue?.id &&
          Array.isArray(selTempLedgerVoucher.partyLedger) &&
          selTempLedgerVoucher.partyLedger.some(
            (led) => led?.id === selPnLEntryValue?.id
          )
            ? [
                ...selTempLedgerVoucher.partyLedger.filter(
                  (led) => led?.id !== selPnLEntryValue?.id
                ),
                selPnLEntryValue,
              ]
            : selTempLedgerVoucher.partyLedger ?? [],
      };

      // To get Closing Stock Ledger from Closing Entry
      let selStockEntryValue =
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.ExpensesnIncome)
          ?.voucher.effectiveLedger.find(
            (led: any) => led.ledgerName === "Closing Stock"
          ) ??
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.ExpensesnIncome)
          ?.voucher.partyLedger.find(
            (led: any) => led.ledgerName === "Closing Stock"
          );
      // To set the changed amount
      if (selStockEntryValue) {
        selStockEntryValue.amount = selStockTempFormValue.amount;
        selStockEntryValue.isDebitNature =
          selStockEntryValue.amount > 0 ? true : false;
      }

      selTempLedgerVoucher = {
        ...selTempLedgerVoucher,
        date: dayjs(voucherDate).toISOString(),
        effectiveLedger:
          selTempLedgerVoucher?.effectiveLedger &&
          selStockEntryValue?.id &&
          Array.isArray(selTempLedgerVoucher.effectiveLedger) &&
          selTempLedgerVoucher.effectiveLedger.some(
            (led) => led?.id === selStockEntryValue?.id
          )
            ? [
                ...selTempLedgerVoucher.effectiveLedger.filter(
                  (led) => led?.id !== selStockEntryValue?.id
                ),
                selStockEntryValue,
              ]
            : selTempLedgerVoucher.effectiveLedger ?? [],
        partyLedger:
          selTempLedgerVoucher?.partyLedger &&
          selStockEntryValue?.id &&
          Array.isArray(selTempLedgerVoucher.partyLedger) &&
          selTempLedgerVoucher.partyLedger.some(
            (led) => led?.id === selStockEntryValue?.id
          )
            ? [
                ...selTempLedgerVoucher.partyLedger.filter(
                  (led) => led?.id !== selStockEntryValue?.id
                ),
                selStockEntryValue,
              ]
            : selTempLedgerVoucher.partyLedger ?? [],
      };

      ////Handling of PermaLedgers form

      // To get Form Value
      let permaLedgersFormValues = permaLedgerForm.getFieldsValue();
      // To select PnL ledger value
      let selPnLPermaFormValue =
        permaLedgersFormValues.partyLedgerPermaLedgers.find(
          (led: any) => led.ledgerName === "Profit & Loss A/c"
        );
      // To select closing stock ledger value
      let selStockPermaFormValue =
        permaLedgersFormValues.partyLedgerPermaLedgers.find(
          (led: any) => led.ledgerName === "Closing Stock"
        );
      // To get PnL Ledger from Closing Entry
      let selPnLPermaEntryValue =
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.AssetsnLiabities)
          ?.voucher.effectiveLedger.find(
            (led: any) => led.ledgerName === "Profit & Loss A/c"
          ) ??
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.AssetsnLiabities)
          ?.voucher.partyLedger.find(
            (led: any) => led.ledgerName === "Profit & Loss A/c"
          );
      // To set the changed amount
      if (selPnLPermaEntryValue) {
        selPnLPermaEntryValue.amount = selPnLPermaFormValue.amount;
        selPnLPermaEntryValue.isDebitNature =
          selPnLPermaEntryValue.amount > 0 ? false : true;
      }

      // To select the tempLedger Voucher from closing entry
      let selPermaLedgerVoucher: IVoucherModel =
        closingEntries?.closingVouchers.find(
          (cl) => cl.entryType === ClosingEntry_Type.AssetsnLiabities
        )?.voucher!;
      selPermaLedgerVoucher = {
        ...selPermaLedgerVoucher,
        date: dayjs(voucherDate).toISOString(),
        effectiveLedger:
          selPermaLedgerVoucher?.effectiveLedger &&
          selPnLPermaEntryValue?.id &&
          Array.isArray(selPermaLedgerVoucher.effectiveLedger) &&
          selPermaLedgerVoucher.effectiveLedger.some(
            (led) => led?.id === selPnLPermaEntryValue?.id
          )
            ? [
                ...selPermaLedgerVoucher.effectiveLedger.filter(
                  (led) => led?.id !== selPnLPermaEntryValue?.id
                ),
                selPnLPermaEntryValue,
              ]
            : selPermaLedgerVoucher.effectiveLedger ?? [],
        partyLedger:
          selPermaLedgerVoucher?.partyLedger &&
          selPnLPermaEntryValue?.id &&
          Array.isArray(selPermaLedgerVoucher.partyLedger) &&
          selPermaLedgerVoucher.partyLedger.some(
            (led) => led?.id === selPnLPermaEntryValue?.id
          )
            ? [
                ...selPermaLedgerVoucher.partyLedger.filter(
                  (led) => led?.id !== selPnLPermaEntryValue?.id
                ),
                selPnLPermaEntryValue,
              ]
            : selPermaLedgerVoucher.partyLedger ?? [],
      };

      // To get Closing Stock Ledger from Closing Entry
      let selStockPermaEntryValue =
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.AssetsnLiabities)
          ?.voucher.effectiveLedger.find(
            (led: any) => led.ledgerName === "Closing Stock"
          ) ??
        closingEntries?.closingVouchers
          .find((cl) => cl.entryType === ClosingEntry_Type.AssetsnLiabities)
          ?.voucher.partyLedger.find(
            (led: any) => led.ledgerName === "Closing Stock"
          );
      // To set the changed amount
      if (selStockPermaEntryValue) {
        selStockPermaEntryValue.amount = selStockPermaFormValue.amount;
        selStockPermaEntryValue.isDebitNature =
          selStockPermaEntryValue.amount > 0 ? true : false;
      }

      selPermaLedgerVoucher = {
        ...selPermaLedgerVoucher,
        effectiveLedger:
          selPermaLedgerVoucher?.effectiveLedger &&
          selStockPermaEntryValue?.id &&
          Array.isArray(selPermaLedgerVoucher.effectiveLedger) &&
          selPermaLedgerVoucher.effectiveLedger.some(
            (led) => led?.id === selStockPermaEntryValue?.id
          )
            ? [
                ...selPermaLedgerVoucher.effectiveLedger.filter(
                  (led) => led?.id !== selStockPermaEntryValue?.id
                ),
                selStockPermaEntryValue,
              ]
            : selPermaLedgerVoucher.effectiveLedger ?? [],
        partyLedger:
          selPermaLedgerVoucher?.partyLedger &&
          selStockPermaEntryValue?.id &&
          Array.isArray(selPermaLedgerVoucher.partyLedger) &&
          selPermaLedgerVoucher.partyLedger.some(
            (led) => led?.id === selStockPermaEntryValue?.id
          )
            ? [
                ...selPermaLedgerVoucher.partyLedger.filter(
                  (led) => led?.id !== selStockPermaEntryValue?.id
                ),
                selStockPermaEntryValue,
              ]
            : selPermaLedgerVoucher.partyLedger ?? [],
      };

      let newClosingVouchers: IClosingEntryItems[] = [
        {
          entryType: ClosingEntry_Type.ExpensesnIncome,
          voucher: selTempLedgerVoucher,
        },
        {
          entryType: ClosingEntry_Type.AssetsnLiabities,
          voucher: selPermaLedgerVoucher,
        },
      ];

      let newClosingEntries: IClosingEntryResponseModel = {
        closingVouchers: newClosingVouchers,
        itemsClosingInvDetail: itemsClosingInvDetail,
      };

      console.log("Post Values: ", newClosingEntries);

      // // let stockValueFormValues = stockValueForm.getFieldsValue();
      // let tempLedgerVoucherValues = closingEntries?.closingVouchers.find(
      //   (cl) => cl.entryType === ClosingEntry_Type.ExpensesnIncome
      // )?.voucher;
      // let permaLedgerVoucherValues = closingEntries?.closingVouchers.find(
      //   (cl) => cl.entryType === ClosingEntry_Type.AssetsnLiabities
      // )?.voucher;
      // let diffStockAmount = totalStockValue - initialStockValue;

      // let selPnLTempLedger =
      //   tempLedgerVoucherValues?.effectiveLedger?.find(
      //     (led: any) => led.ledgerName === "Profit & Loss A/c"
      //   ) ||
      //   tempLedgerVoucherValues?.partyLedger?.find(
      //     (led: any) => led.ledgerName === "Profit & Loss A/c"
      //   );

      // let selStockTempLedger =
      //   tempLedgerVoucherValues?.effectiveLedger?.find(
      //     (led: any) => led.ledgerName === "Closing Stock"
      //   ) ||
      //   tempLedgerVoucherValues?.partyLedger?.find(
      //     (led: any) => led.ledgerName === "Closing Stock"
      //   );

      // let selPnLPermaLedger =
      //   permaLedgerVoucherValues?.effectiveLedger?.find(
      //     (led: any) => led.ledgerName === "Profit & Loss A/c"
      //   ) ||
      //   permaLedgerVoucherValues?.partyLedger?.find(
      //     (led: any) => led.ledgerName === "Profit & Loss A/c"
      //   );
      // let selStockPermaLedger =
      //   permaLedgerVoucherValues?.effectiveLedger?.find(
      //     (led: any) => led.ledgerName === "Closing Stock"
      //   ) ||
      //   permaLedgerVoucherValues?.partyLedger?.find(
      //     (led: any) => led.ledgerName === "Closing Stock"
      //   );
      // //To update the tempLedger entries
      // if (selPnLTempLedger) {
      //   if (diffStockAmount !== 0 && selPnLTempLedger?.amount !== 0) {
      //     selPnLTempLedger.amount = selPnLTempLedger.amount - diffStockAmount;
      //     selPnLTempLedger.amount -= diffStockAmount;
      //   }
      //   if (diffStockAmount !== 0 && selPnLTempLedger.amount !== 0) {
      //     selPnLTempLedger.amount = selPnLTempLedger.amount + diffStockAmount;
      //     selPnLTempLedger.amount += diffStockAmount;
      //   }
      // }
      // if (selStockTempLedger) {
      //   if (diffStockAmount !== 0 && selStockTempLedger.amount !== 0) {
      //     selStockTempLedger.amount =
      //       selStockTempLedger.amount + diffStockAmount;
      //     selStockTempLedger.amount += diffStockAmount;
      //   }
      // }
      // let prevTempVoucherValues = {
      //   ...tempLedgerVoucherValues,
      //   effectiveLedger: tempLedgerVoucherValues?.effectiveLedger.filter(
      //     (led) =>
      //       led.id !== selPnLTempLedger?.id && led.id !== selStockTempLedger?.id
      //   ),
      //   partyLedger: tempLedgerVoucherValues?.partyLedger.filter(
      //     (led) =>
      //       led.id !== selPnLTempLedger?.id && led.id !== selStockTempLedger?.id
      //   ),
      // };

      // let newTempVoucherValues: IVoucherModel = {
      //   ...prevTempVoucherValues,
      //   date: dayjs(dateForm.getFieldValue("date")).toISOString(),
      //   dueDate: dayjs(dateForm.getFieldValue("date")).toISOString(),
      //   voucherType: Voucher_Type.Journal,
      //   effectiveLedger:
      //     selPnLTempLedger &&
      //     Array.isArray(prevTempVoucherValues.effectiveLedger) &&
      //     tempLedgerVoucherValues?.effectiveLedger.some(
      //       (led) => led?.id === selPnLTempLedger?.id
      //     )
      //       ? [...prevTempVoucherValues.effectiveLedger, selPnLTempLedger]
      //       : prevTempVoucherValues.effectiveLedger ?? [],
      //   partyLedger:
      //     selPnLTempLedger &&
      //     Array.isArray(prevTempVoucherValues.partyLedger) &&
      //     tempLedgerVoucherValues?.partyLedger.some(
      //       (led) => led?.id === selPnLTempLedger?.id
      //     )
      //       ? [...prevTempVoucherValues.partyLedger, selPnLTempLedger]
      //       : prevTempVoucherValues.partyLedger ?? [],
      // };

      // //To update the permaLedger entries
      // if (selPnLPermaLedger) {
      //   if (diffStockAmount !== 0 && selPnLPermaLedger?.amount !== 0) {
      //     selPnLPermaLedger.amount = selPnLPermaLedger.amount - diffStockAmount;
      //     selPnLPermaLedger.amount -= diffStockAmount;
      //   }
      //   if (diffStockAmount !== 0 && selPnLPermaLedger.amount !== 0) {
      //     selPnLPermaLedger.amount = selPnLPermaLedger.amount + diffStockAmount;
      //     selPnLPermaLedger.amount += diffStockAmount;
      //   }
      // }
      // if (selStockPermaLedger) {
      //   if (diffStockAmount !== 0 && selStockPermaLedger.amount !== 0) {
      //     selStockPermaLedger.amount =
      //       selStockPermaLedger.amount + diffStockAmount;
      //     selStockPermaLedger.amount += diffStockAmount;
      //   }
      // }
      // let prevPermaVoucherValues = {
      //   ...permaLedgerVoucherValues,
      //   effectiveLedger: permaLedgerVoucherValues?.effectiveLedger.filter(
      //     (led) =>
      //       led.id !== selPnLPermaLedger?.id &&
      //       led.id !== selStockPermaLedger?.id
      //   ),
      //   partyLedger: permaLedgerVoucherValues?.partyLedger.filter(
      //     (led) =>
      //       led.id !== selPnLPermaLedger?.id &&
      //       led.id !== selStockPermaLedger?.id
      //   ),
      // };

      // let newPermaVoucherValues: IVoucherModel = {
      //   ...prevPermaVoucherValues,
      //   date: dayjs(dateForm.getFieldValue("date")).toISOString(),
      //   dueDate: dayjs(dateForm.getFieldValue("date")).toISOString(),
      //   voucherType: Voucher_Type.Journal,
      //   effectiveLedger:
      //     selPnLPermaLedger &&
      //     Array.isArray(prevPermaVoucherValues.effectiveLedger) &&
      //     permaLedgerVoucherValues?.effectiveLedger.some(
      //       (led) => led?.id === selPnLPermaLedger?.id
      //     )
      //       ? [...prevPermaVoucherValues.effectiveLedger, selPnLPermaLedger]
      //       : prevPermaVoucherValues.effectiveLedger ?? [],
      //   partyLedger:
      //     selPnLPermaLedger &&
      //     Array.isArray(prevPermaVoucherValues.partyLedger) &&
      //     permaLedgerVoucherValues?.partyLedger.some(
      //       (led) => led?.id === selPnLPermaLedger?.id
      //     )
      //       ? [...prevPermaVoucherValues.partyLedger, selPnLPermaLedger]
      //       : prevPermaVoucherValues.partyLedger ?? [],
      // };
      // let newClosingVouchers: IClosingEntryItems[] = [
      //   {
      //     entryType: ClosingEntry_Type.ExpensesnIncome,
      //     voucher: newTempVoucherValues,
      //   },
      //   {
      //     entryType: ClosingEntry_Type.AssetsnLiabities,
      //     voucher: newPermaVoucherValues,
      //   },
      // ];

      // console.log("Post Values: ", newClosingVouchers);

      setLoading(true);
      setSaveButtonLoading(true);

      let closingEntryRes = await VoucherServices.CreateClosingEntries(
        currentClient?.id!,
        period.from,
        period.to,
        newClosingEntries!
      )
        .then(async (res) => {
          if (res?.result && res?.status) {
            openNotification("success", "Closing entry successfully posted.");
            setLoading(false);
            setSaveButtonLoading(false);
          } else {
            openNotification("error", res?.message ?? "Something went wrong!");
            setLoading(false);
            setSaveButtonLoading(false);
          }
        })
        .catch((ex) => {
          openNotification("error", ex);
          setLoading(false);
          setSaveButtonLoading(false);
        });
    } catch (error) {
      console.log("error", error);
      setSaveButtonLoading(false);
      setLoading(false);
    }
  };

  const columns: ColumnsType<IItemInvCloOpResponse> = [
    {
      title: "S.No.",
      width: "5%",
      key: "id",
      render: (_, record, index: number) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {index + 1}
        </Skeleton>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "Name",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.name}
        </Skeleton>
      ),
    },
    {
      title: "Tax Preference",
      dataIndex: "isTaxable",
      key: "IsTaxable",
      width: "15%",
      render: (_, record) => {
        if (record?.isTaxable === true)
          return (
            <Skeleton
              active
              loading={loading}
              paragraph={{ rows: 1 }}
              title={false}
            >
              <Tag
                color="cyan"
                style={{
                  textAlign: "center",
                  width: 85,
                }}
              >
                Inclusive Tax
              </Tag>
            </Skeleton>
          );
        else
          return (
            <Skeleton
              active
              loading={loading}
              paragraph={{ rows: 1 }}
              title={false}
            >
              <Tag
                // bordered={false}
                color="purple"
                style={{
                  textAlign: "center",
                  width: 85,
                }}
              >
                Exclusive Tax
              </Tag>
            </Skeleton>
          );
      },
    },
    {
      title: "GST",
      dataIndex: "gstRate",
      key: "Rate",
      width: "8%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.taxRate + "%"}
        </Skeleton>
      ),
    },
    {
      title: "Pur. Price",
      dataIndex: "unitPrice",
      width: "15%",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {record?.purchasePrice || record?.purchasePrice === 0
            ? Utils.getFormattedNumber(record?.purchasePrice)
            : "-"}
        </Skeleton>
      ),
    },
    {
      title: "Average Pur. Price",
      width: "15%",
      align: "right",
      render: (_, record) => {
        let purDetail = record.invDetail?.filter(
          (inv: IItemInventory) => inv.adjust === Adjust_Type.Add
        );
        let purPriceTotal = purDetail?.reduce(
          (acc: number, rec: IItemInventory) => acc + rec.price,
          0
        );
        return (
          <Skeleton
            active
            loading={loading}
            paragraph={{
              rows: 1,
              style: { display: "flex", justifyContent: "end" },
            }}
            title={false}
          >
            {Utils.getFormattedNumber(purPriceTotal! / purDetail?.length!)}
          </Skeleton>
        );
      },
    },
    {
      title: "Available Qty",
      dataIndex: "qty",
      width: "15%",
      align: "right",
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {val}
        </Skeleton>
      ),
    },

    {
      title: "Stock Value",
      dataIndex: "stockValue",
      width: "10%",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <Form.Item name={record.id} style={{ marginBottom: 0 }}>
            <InputNumber
              style={{ width: 150 }}
              value={record?.stockValue}
              precision={2}
              type="number"
              onKeyPress={handleDecimalValues}
              min={0}
              step={0.1}
              onBlur={() => {
                setTotalStockValue(
                  Object.values(stockValueForm.getFieldsValue()).reduce(
                    (acc: number, val: any) => acc + val,
                    0
                  )
                );
              }}
            />
          </Form.Item>
        </Skeleton>
      ),
    },
  ];
  const items: CollapseProps["items"] = [
    {
      key: "stock",
      label: "Stock",
      showArrow: false,
      children: (
        <div style={{ padding: "2px", margin: "2px" }}>
          <div>
            <Form form={stockValueForm} name="depForm">
              <Table
                columns={columns}
                dataSource={closingEntries?.itemsClosingInvDetail}
                pagination={false}
              />
            </Form>
          </div>
          <div style={{ marginTop: "10px", width: "100%", textAlign: "right" }}>
            Total Stock Value : {totalStockValue}
          </div>
          <div style={{ marginTop: "10px" }}>
            <Button
              onClick={handleStockValueChange}
              type="primary"
              disabled={initialStockValue === totalStockValue}
            >
              Pass stock values to Closing Balance
            </Button>
          </div>
          {/* <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              spinning={loading}
            >
              <Form
                form={itemsform}
                autoComplete="off"
                name="openingBalanceForItems"
                disabled={isDisabled}
                initialValues={{
                  partyLedgerItems: [{}],
                }}
              >
                <div>
                  <table className="AddPageTabelDesign">
                    <thead>
                      <tr>
                        <th style={{ width: "60%" }}>Account</th>
                        <th style={{ width: "20%" }}>Debit</th>
                        <th colSpan={2} style={{ width: "20%" }}>
                          Credit
                        </th>
                      </tr>
                    </thead>
                    <Form.List name="partyLedgerItems">
                      {(fields, { add, remove }) => {
                        return (
                          <>
                            <tbody>
                              {fields.map(
                                (
                                  { key, name, ...restField }: any,
                                  index: number
                                ) => {
                                  return (
                                    <tr key={key}>
                                      <td>
                                        <Form.Item
                                          name={[name, "id"]}
                                          className="m-0"
                                          {...restField}
                                        >
                                          <Select
                                            disabled
                                            labelInValue
                                            showSearch
                                            placeholder="Search to items"
                                            optionFilterProp="children"
                                            popupMatchSelectWidth={false}
                                            style={{ width: "100%" }}
                                            dropdownStyle={{
                                              width: "250px",
                                            }}
                                            placement="bottomRight"
                                            options={partyLedgerOptionOtherAsset
                                              .filter(
                                                (option) =>
                                                  option.partyOrTax ===
                                                  Party_Tax.Stock
                                              )
                                              .map((option: any) => ({
                                                value: option?.id,
                                                label: option?.ledgerName,
                                                title: option?.partyOrTax,
                                              }))}
                                            filterOption={(input, option) =>
                                              (option?.label?.toString() ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "debit"]}
                                          {...restField}
                                          className="m-0"
                                          initialValue={Utils.getFormattedNumber(
                                            0
                                          )}
                                        >
                                          <Input disabled className="textEnd" />
                                        </Form.Item>
                                      </td>
                                      <td style={{ width: "100%" }}>
                                        <Form.Item
                                          name={[name, "credit"]}
                                          {...restField}
                                          className="m-0"
                                          initialValue={Utils.getFormattedNumber(
                                            0
                                          )}
                                        >
                                          <Input disabled className="textEnd" />
                                        </Form.Item>
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </>
                        );
                      }}
                    </Form.List>
                  </table>
                </div>
              </Form>
              <Row className=" pt-10 mt-14">
                <Col lg={12}></Col>
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>Total</Col>
                    <Col lg={10} className="textEnd">
                      <span style={{ paddingRight: "12px" }}>
                        ₹ {Utils.getFormattedNumber(debitTotalItems)}
                      </span>
                    </Col>
                    <Col lg={10} className="textEnd">
                      <span style={{ paddingRight: "12px" }}>
                        ₹ {Utils.getFormattedNumber(creditTotalItems)}
                      </span>
                    </Col>
                  </Row>
                  <Divider className="my-5 grayBg" />
                </Col>
              </Row>
            </Spin>
          </div> */}
        </div>
      ),
      // extra: (
      //   <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
      //     <Row style={{ gap: "5px" }}>
      //       <Col> Debit : </Col>
      //       <Col className="fw-600">
      //         ₹ {Utils.getFormattedNumber(debitTotalItems)}
      //       </Col>
      //     </Row>
      //     <Row style={{ gap: "5px" }}>
      //       <Col> Credit : </Col>
      //       <Col className="fw-600">
      //         ₹ {Utils.getFormattedNumber(creditTotalItems)}
      //       </Col>
      //     </Row>
      //     <Col style={{ paddingRight: "30px" }}></Col>
      //   </Row>
      // ),
    },
    {
      key: "tempLedgers",
      label: "Expenses & Incomes",
      showArrow: false,
      children: (
        <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            spinning={loading}
          >
            <Form
              form={tempLedgerForm}
              autoComplete="off"
              name="tempLedgers"
              disabled={isDisabled}
              initialValues={{
                partyLedgerTempLedgers: [{}],
              }}
            >
              <div>
                <table className="AddPageTabelDesign">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Account</th>
                      <th style={{ width: "20%" }}>Debit</th>
                      <th colSpan={2} style={{ width: "20%" }}>
                        Credit
                      </th>
                    </tr>
                  </thead>
                  <Form.List name="partyLedgerTempLedgers">
                    {(fields, { add, remove }) => {
                      return (
                        <>
                          <tbody>
                            {fields.map(
                              (
                                { key, name, ...restField }: any,
                                index: number
                              ) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      <Form.Item
                                        name={[name, "id"]}
                                        className="m-0"
                                        {...restField}
                                      >
                                        <Select
                                          disabled
                                          placeholder="Search ledger"
                                          style={{ width: "100%" }}
                                          placement="bottomRight"
                                          options={partyLedgerOptionTempLedger.map(
                                            (option: any) => ({
                                              value: option?.id,
                                              label: option?.ledgerName,
                                              title: option?.partyOrTax,
                                            })
                                          )}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td>
                                      <Form.Item
                                        name={[name, "debit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input disabled className="textEnd" />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                      <Form.Item
                                        name={[name, "credit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input disabled className="textEnd" />
                                      </Form.Item>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </>
                      );
                    }}
                  </Form.List>
                </table>
              </div>
              <Form.Item name="narration" style={{ marginTop: "20px" }}>
                <TextArea
                  autoSize={{ minRows: 2, maxRows: 4 }}
                  placeholder="Write narration"
                ></TextArea>
              </Form.Item>
            </Form>
            <Row className=" pt-10 mt-14">
              <Col lg={12}></Col>
              <Col lg={12}>
                <Row>
                  <Col lg={4}>Total</Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(debitTotalTempLedger)}
                    </span>
                  </Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(creditTotalTempLedger)}
                    </span>
                  </Col>
                </Row>
                <Divider className="my-5 grayBg" />
              </Col>
            </Row>
          </Spin>
        </div>
      ),
      extra: (
        <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
          <Row style={{ gap: "5px" }}>
            <Col>Debit : </Col>{" "}
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(debitTotalTempLedger)}
            </Col>
          </Row>
          <Row style={{ gap: "5px" }}>
            <Col>Credit : </Col>
            <Col className="fw-600">
              {" "}
              ₹ {Utils.getFormattedNumber(creditTotalTempLedger)}
            </Col>
          </Row>
          <Col style={{ paddingRight: "30px" }}></Col>
        </Row>
      ),
    },
    {
      key: "permaLedgers",
      label: "Assets & Liabilities",
      showArrow: false,
      children: (
        <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            spinning={loading}
          >
            <Form
              form={permaLedgerForm}
              autoComplete="off"
              name="permaLedgers"
              disabled={isDisabled}
              initialValues={{
                partyLedgerPermaLedgers: [{}],
              }}
            >
              <div>
                <table className="AddPageTabelDesign">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Account</th>
                      <th style={{ width: "20%" }}>Debit</th>
                      <th colSpan={2} style={{ width: "20%" }}>
                        Credit
                      </th>
                    </tr>
                  </thead>
                  <Form.List name="partyLedgerPermaLedgers">
                    {(fields, { add, remove }) => {
                      return (
                        <>
                          <tbody>
                            {fields.map(
                              (
                                { key, name, ...restField }: any,
                                index: number
                              ) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      <Form.Item
                                        name={[name, "id"]}
                                        className="m-0"
                                        {...restField}
                                      >
                                        <Select
                                          disabled
                                          placeholder="Search to ledger"
                                          style={{ width: "100%" }}
                                          placement="bottomRight"
                                          options={partyLedgerOptionPermaLedger.map(
                                            (option: any) => ({
                                              value: option?.id,
                                              label: option?.ledgerName,
                                              title: option?.partyOrTax,
                                            })
                                          )}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td>
                                      <Form.Item
                                        name={[name, "debit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input disabled className="textEnd" />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                      <Form.Item
                                        name={[name, "credit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input disabled className="textEnd" />
                                      </Form.Item>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </>
                      );
                    }}
                  </Form.List>
                </table>
              </div>
              <Form.Item name="narration" style={{ marginTop: "20px" }}>
                <TextArea
                  autoSize={{ minRows: 2, maxRows: 4 }}
                  placeholder="Write narration"
                ></TextArea>
              </Form.Item>
            </Form>
            <Row className=" pt-10 mt-14">
              <Col lg={12}></Col>
              <Col lg={12}>
                <Row>
                  <Col lg={4}>Total</Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(debitTotalPermaLedger)}
                    </span>
                  </Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(creditTotalPermaLedger)}
                    </span>
                  </Col>
                </Row>
                <Divider className="my-5 grayBg" />
              </Col>
            </Row>
          </Spin>
        </div>
      ),
      extra: (
        <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
          <Row style={{ gap: "5px" }}>
            <Col>Debit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(debitTotalPermaLedger)}
            </Col>
          </Row>
          <Row style={{ gap: "5px" }}>
            <Col>Credit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(creditTotalPermaLedger)}
            </Col>
          </Row>
          <Col style={{ paddingRight: "30px" }}></Col>
        </Row>
      ),
    },
  ];

  useEffect(() => {
    if (
      partyLedgerOptionOtherAsset?.length > 0 &&
      closingEntries?.itemsClosingInvDetail
    ) {
      let creditAmount = closingEntries?.itemsClosingInvDetail?.reduce(
        (acc: number, itm: IItemInvCloOpResponse) => acc + itm?.stockValue!,
        0
      );
      // let itemData = [
      //   {
      //     id: partyLedgerOptionOtherAsset?.find(
      //       (led: any) => led.ledgerName === "Closing Stock"
      //     )?.id,
      //     debit: 0,
      //     credit: creditAmount,
      //   },
      // ];
      // itemsform?.setFieldValue("partyLedgerItems", itemData);
      setCreditTotalItems(creditAmount);
    }
  }, [closingEntries?.itemsClosingInvDetail, partyLedgerOptionOtherAsset]);

  const totalAmountDebit = Math.round(
    debitTotalTempLedger + debitTotalPermaLedger
  );
  const totalAmountCredit = Math.round(
    creditTotalTempLedger + creditTotalPermaLedger
  );

  return (
    <Spin spinning={loading}>
      <Row justify={"space-between"} style={{ marginBottom: "15px" }}>
        <Col className="dashedBoxStyle" style={{ alignContent: "flex-start" }}>
          <Space>
            <span>Closing entry as on</span>
            <Form
              form={dateForm}
              autoComplete="off"
              name="date"
              initialValues={{
                date: dayjs(period?.to),
              }}
            >
              <Form.Item
                className="m-0"
                name="date"
                rules={[{ required: true, message: "Select a date" }]}
              >
                <DatePicker
                  allowClear={false}
                  format={"DD/MM/YYYY"}
                  disabledDate={(current) =>
                    current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                  }
                />
              </Form.Item>
            </Form>
          </Space>
        </Col>
      </Row>
      <Card
        size="small"
        // className="TableCard"
        style={{
          marginTop: 5,
          borderRadius: 0,
          boxShadow: "0px 0px 4px 0px #96A1C84D",
          overflowY: "scroll",
          height: "64vh",
        }}
      >
        <Collapse
          items={items}
          activeKey={["permaLedgers", "tempLedgers", "stock"]}
        />
      </Card>
      <Row style={{ margin: "15px 0px", position: "sticky" }}>
        <Col span={24} style={{ display: "flex", justifyContent: "right" }}>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            disabled={
              totalAmountCredit === totalAmountDebit &&
              totalAmountCredit !== 0 &&
              totalAmountDebit !== 0 &&
              !isDisabled
                ? false
                : true
            }
            loading={saveButtonLoading}
            onClick={() => postClosingEntry()}
          >
            Submit Closing Entries
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default ClosingEntries;
